import type { ComponentProps } from 'react';
import { Link } from 'react-router-dom';
import { useLinkOpener } from './use-link-opener';

/**
 * A router Link to a factory page that, in the chat and task comments (LinksOpenInDialogs), opens in
 * the link dialog as their text's links do (SF-T-160); elsewhere it's an ordinary Link. For links the
 * chat draws itself: a suggestion's task, the chat's focus project.
 */
export function DialogLink({ to, onClick, ...props }: Omit<ComponentProps<typeof Link>, 'to'> & { to: string }) {
  const opener = useLinkOpener();
  return (
    <Link
      to={to}
      data-keeps-page={opener.keepsPage(to) ? '' : undefined}
      onClick={(event) => {
        if (!opener.onInternalClick(to, event)) onClick?.(event);
      }}
      {...props}
    />
  );
}
